import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDestinos } from "../api";
import "../assets/css/style.css";
import { motion } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Destinos = () => {
  const [destinos, setDestinos] = useState([]);
  const [loading, setLoading] = useState(true);
  const showSplash = useDynamicSplash(loading);
  const navigate = useNavigate();

  useEffect(() => {
    const cargarDestinos = async () => {
      setLoading(true);
      document.body.style.overflow = "hidden";
      try {
        const res = await getDestinos();
        setDestinos(res.destinos || []);
      } finally {
        setLoading(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };
    cargarDestinos();
  }, []);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/home")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Destinos</h2>
      </div>

      <div className="destinos-list">
        {destinos.length > 0 ? (
          destinos.map((destino) => (
            <div className="destino-card" key={destino.id_destino} onClick={() => {
              navigate("/destinos", { replace: true }); // 👉 esto inserta /destinos como "anterior"
              navigate(`/destino/${destino.id_destino}`, { state: { from: "all" } }); // 👉 y luego navega
            }}>
              <img src={destino.portada || "/assets/images/default.png"} alt={destino.nombre} className="destino-img" />
              <div className="destino-nombre">{destino.nombre}</div>
              <div className="destino-info">
                <p class="detalle-ubicacion rmb"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64"></path><path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"></path></g></svg><b>Ubicación:</b> {destino.municipio}.</p>
                <div class="recomendaste mbr"><span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="currentColor" d="m20.975 12.185l-.739-.128zm-.705 4.08l-.74-.128zM6.938 20.477l-.747.065zm-.812-9.393l.747-.064zm7.869-5.863l.74.122zm-.663 4.045l.74.121zm-6.634.411l-.49-.568zm1.439-1.24l.49.569zm2.381-3.653l-.726-.189zm.476-1.834l.726.188zm1.674-.886l-.23.714zm.145.047l.229-.714zM9.862 6.463l.662.353zm4.043-3.215l-.726.188zm-2.23-1.116l-.326-.675zm8.561 9.925l-.705 4.08l1.478.256l.705-4.08zm-6.991 9.193H8.596v1.5h4.649zm-5.56-.837l-.812-9.393l-1.495.129l.813 9.393zm11.846-4.276c-.507 2.93-3.15 5.113-6.286 5.113v1.5c3.826 0 7.126-2.669 7.764-6.357zM13.255 5.1l-.663 4.045l1.48.242l.663-4.044zm-6.067 5.146l1.438-1.24l-.979-1.136L6.21 9.11zm4.056-5.274l.476-1.834l-1.452-.376l-.476 1.833zm1.194-2.194l.145.047l.459-1.428l-.145-.047zm-1.915 4.038a8.4 8.4 0 0 0 .721-1.844l-1.452-.377A7 7 0 0 1 9.2 6.11zm2.06-3.991a.89.89 0 0 1 .596.61l1.452-.376a2.38 2.38 0 0 0-1.59-1.662zm-.863.313a.51.51 0 0 1 .28-.33l-.651-1.351c-.532.256-.932.73-1.081 1.305zm.28-.33a.6.6 0 0 1 .438-.03l.459-1.428a2.1 2.1 0 0 0-1.548.107zm2.154 8.176h5.18v-1.5h-5.18zm.581-5.641a5.5 5.5 0 0 0-.104-2.284l-1.452.377a4 4 0 0 1 .076 1.664zM8.596 21.25a.916.916 0 0 1-.911-.837l-1.494.129a2.416 2.416 0 0 0 2.405 2.208zm.03-12.244c.68-.586 1.413-1.283 1.898-2.19L9.2 6.109c-.346.649-.898 1.196-1.553 1.76zm13.088 3.307a2.416 2.416 0 0 0-2.38-2.829v1.5c.567 0 1 .512.902 1.073zm-9.122-3.168a1.583 1.583 0 0 0 1.562 1.84v-1.5a.083.083 0 0 1-.082-.098zm-5.72 1.875a.92.92 0 0 1 .316-.774l-.98-1.137a2.42 2.42 0 0 0-.83 2.04z"></path><path fill="currentColor" d="m3.972 21.47l-.748.066zM3 10.235l.747-.064a.75.75 0 0 0-1.497.064zm1.719 11.172L3.747 10.17l-1.494.129l.971 11.237zm-.969.107v-11.28h-1.5v11.279zm-.526.022a.263.263 0 0 1 .263-.285v1.5c.726 0 1.294-.622 1.232-1.344zm.263-.285c.146 0 .263.119.263.263h-1.5c0 .682.553 1.237 1.237 1.237z"></path></svg> <b>{destino.recomendaciones}</b> personas recomiendan este lugar.</span></div>
              </div>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", padding: "1rem" }}>Aún no hay destinos disponibles.</p>
        )}
      </div>
    </div>
	</motion.div>
    )}
    </>
  );
};

export default Destinos;
